var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"layout layout--center\"><div class=\"layout__item u-1/3-extralarge-and-up u-1/2-large u-2/3-medium\"><div class=\"layout--center\"><svg role=\"img\" class=\"c-logo c-logo--large c-logo--blue\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#logo-youappi\"></use></svg></div><div class=\"c-panel\"><form ng-keypress=\"($event.which===13) &amp;&amp; vm.requestPassword()\"><div ng-form=\"vm.form\" novalidate=\"\" class=\"form layout\"><formly-form model=\"vm.user\" fields=\"vm.fields\"></formly-form></div><div class=\"c-panel__footer\"><div class=\"layout layout--auto layout--middle\"><div class=\"layout__item u-1/2\"><a ui-sref=\"login\">{{ 'backToLogin' | translate }}</a></div><div class=\"layout__item text-right u-1/2\"><a id=\"login-btn\" ng-click=\"vm.form.$valid &amp;&amp; vm.requestPassword()\" ng-class=\"{'is-disabled': vm.form.$invalid}\" class=\"o-btn c-btn c-btn--outlined\">{{ 'reset' | translateWith:'password' }}</a></div></div></div></form></div></div></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/account/password/passwordForgot.jade
 ** module id = 605
 ** module chunks = 0
 **/